import { PresetsContainer } from './flow-presets.style'
import { PageHeader } from 'components/page-header/page-header'
import { BulbOutlined } from '@ant-design/icons'
import { useTranslate } from 'utils'
import { FlowCard } from 'components/flow/flow-card/flow-card'
import { useConfig, useFlowPresets, useFlows } from 'api'
import { Loading, PageContentWrapper, PageError, VerticalContainer } from 'components/styled'
import { useNavigate } from 'react-router-dom'
import { VerticalPaginatedList } from 'components/vertical-paginated-list/vertical-paginated-list'
import { useEffect } from 'react'
import { Feature } from 'types'
import { theme } from 'antd'

export const FlowPresets = () => {
    
    //hooks:
    const { token: { marginXS } } = theme.useToken()
    const { __ } = useTranslate()
    const { data: config } = useConfig()
    const navigate = useNavigate()
    
    //flows:
    const { data: allFlows, total, isLoading: isFlowsLoading } = useFlows(null)

    //flow presets:
    const {
        data: flowPresets,
        pageNum,
        totalPages,
        isLoading: isFlowPresetsLoading,
        isPreviousData,
        isNextDisabled,
        isPreviousDisabled,
        fetchNext,
        fetchPrevious
    } = useFlowPresets(null, 12)

    // redirect if it doesn't have access to flow:
    useEffect(() => {
        if(config && allFlows){
            if(!config.features.includes(Feature.FLOWS)){
                navigate('/')
            }else if(allFlows && (total ?? 0) >= (config.plan?.maxFlows ?? 0)){
                navigate('/flow')
            }
        }
    }, [config, allFlows, total])
    
    return (
        (isFlowPresetsLoading || isFlowsLoading) ? <Loading/> : 
        (!flowPresets || !allFlows) ? <PageError/> : (
        
        <PageContentWrapper fullWidth>
        
            <VerticalContainer style={{ gap: marginXS }}>

                {/* header */}
                <PageHeader
                    title={__`create_flow`}
                    description={__`choose_from_a_flow_below_or_start_one_from_scratch`}
                    primaryButton={{
                        name: __`start_from_scratch`,
                        icon: <BulbOutlined/>,
                        onClick: () => navigate('/flow/new')
                    }}
                    backButton={{
                        name: __`back`,
                        onClick: () => navigate('/flow')
                    }}
                />

                {/* list */}
                <VerticalPaginatedList
                    isFirstLoading={isFlowPresetsLoading}
                    isForbidden={flowPresets === null}
                    isError={false}
                    notFound={(flowPresets && flowPresets.length === 0) ?? false}
                    totalPages={totalPages}
                    pageNum={pageNum}
                    isPreviousData={isPreviousData}
                    isNextDisabled={isNextDisabled}
                    isPreviousDisabled={isPreviousDisabled}
                    fetchNext={fetchNext}
                    fetchPrevious={fetchPrevious}
                >
                    
                    <PresetsContainer>
                        {flowPresets && flowPresets.map(flowPreset => flowPreset.listed &&
                            <FlowCard key={flowPreset.id} flowPreset={flowPreset}/>
                        )}
                    </PresetsContainer>

                </VerticalPaginatedList>

            </VerticalContainer>

        </PageContentWrapper>

    ))
}
